import React from 'react'
import PageLoaderStyled from './styled';
import { ReactComponent as LoaderCircles } from '../../assets/img/loader-circles.svg';

const PageLoader = () => (
  <PageLoaderStyled>
    <LoaderCircles />
  </PageLoaderStyled>
)

export default PageLoader;